import React, { Component } from 'react';
import { stores } from '@kurtosys/app-start';
import { components } from '@kurtosys/ksys-app-components';
import { common } from '@kurtosys/ksys-app-template';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';

import { IComponentStylesBase, IConfiguration } from '../../models';
import ColumnSelector from '../ColumnSelector/ColumnSelector';
import { InjectedStyledComponent } from '../shared/InjectedStyledComponent';

import { ITableComponentProps as IAppTableComponentProps } from './models/ITableComponentProps';
import { IPerformanceRow } from './models/ITablePerformanceRow';
import Wrapper from './styledComponents/Wrapper';
import { ITableProps, ITableState } from './models';

const TableComponent = components.base.Table.Table;

export class RawTable extends Component<ITableProps, ITableState> {
	static configurationKey = 'table' as const;
	static styleKey = 'table' as const;
	constructor(props: ITableProps) {
		super(props);
	}

	getTableComponent(props: IAppTableComponentProps | undefined): React.ReactNode {
		if (common.commonUtils.isArrayLike(props)) {
			const { tableStore } = this.props;
			const queryStore =
				tableStore.storeContext.get<stores.QueryStore<IConfiguration, IComponentStylesBase>>('queryStore');
			return props.map((prop, index) => {
				if (prop && prop.grouping) {
					prop.grouping.fetchChildren = tableStore.fetchChildren;
					if (prop.grouping.hideToggleConditional) {
						prop.grouping.hideToggle = tableStore.hideToggle;
					}
					if (prop.grouping.disableToggleConditional) {
						prop.grouping.disableToggle = tableStore.disableToggle;
					}
				}
				return (
					<TableComponent
						key={index}
						queryStore={queryStore}
						{...(prop as components.base.Table.models.ITableProps<IPerformanceRow>)}
					/>
				);
			});
		}
	}

	@computed
	get renderContent() {
		const { tableStore } = this.props;
		if (tableStore) {
			const { props } = tableStore;
			return this.getTableComponent(props);
		}
	}

	render() {
		const { className, tableStore, columnSelectorStore } = this.props;

		if (!tableStore) {
			return null;
		}

		return (
			<Wrapper className={className}>
				{columnSelectorStore.showColumnSelector && <ColumnSelector />}
				{this.renderContent}
			</Wrapper>
		);
	}
}

export const Table = inject('appStore', 'tableStore', 'columnSelectorStore')(observer(RawTable));
export default InjectedStyledComponent(Table, 'table');
